// Department types
export const DEPARTMENTS = {
    MARKETING: 'MARKETING',
    SUPPLY_CHAIN: 'SUPPLY_CHAIN'
};

// Labels and text
export const LABELS = {
    SUPPORT_REQUEST: 'Support Request',
    NO_SUPPORT_MESSAGE: 'No support has been requested for this exit plan implementation.',
    MARKETING_DEPARTMENT: 'Marketing Department',
    SUPPLY_CHAIN_DEPARTMENT: 'Supply Chain Department',
    SUPPORT_PROVIDED: 'Support Provided',
    WAITING_FOR_SUPPORT: 'Waiting for Support',
    NO_MEMBER_SELECTED: 'No team member selected',
    NO_COMMENT_YET: 'No comment provided yet.',
    NO_COMMENT_PROVIDED: 'No comment provided.',
    COMMENT: 'Comment:',
    APPROVED: 'Approved',
    NOT_APPROVED: 'Not Approved',
    CLOSE: 'Close',
    EXPAND_COMMENT: 'Expand comment'
};

// Icon configurations
export const ICON_CONFIG = {
    MARKETING: {
        icon: 'CampaignIcon',
        label: LABELS.MARKETING_DEPARTMENT
    },
    SUPPLY_CHAIN: {
        icon: 'LocalShippingIcon',
        label: LABELS.SUPPLY_CHAIN_DEPARTMENT
    }
};

// Style constants
export const STYLE_CONSTANTS = {
    MAX_COMMENT_HEIGHT: 100,
    ICON_SCALE: '0.8',
    PERSON_ICON_SIZE: '0.9rem',
    FONT_SIZES: {
        SUBTITLE: '0.95rem',
        BODY: '0.9rem',
        SMALL: '0.85rem'
    }
};